export const GET_INQUIRIES = "inquiry/GET_INQUIRY";
export const GET_INQUIRES_PAGE = "inquiry/GET_INQUIRY_PAGE";

export const getInquiry = page => ({
  type: GET_INQUIRIES,
  page
});

export default function inquiry(
  state = { totalLength: 0, pageNumber: 1, inquiry: [] },
  action
) {
  switch (action.type) {
    case GET_INQUIRIES:
      
      return {
        ...state,
        totalLength: action.total_record,
        inquiry: action.inquiry
      };
    case GET_INQUIRES_PAGE:
      return {
        ...state,
        inquiry: action.inquiry,
        pageNumber: action.pageNumber
      };
    default:
      return state;
  }
}
